import { Modal } from "antd";
import styled from "styled-components";
export const Content = styled(Modal)`
.ant-modal-content{
  border-radius: 8px;

}
.ant-modal-header{
  border-radius: 8px;

}
.ant-modal-body{
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

  .actions{
    width: '100%';
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
  }
  .title{
    font-size: 18px;
    font-weight: 500;
    color: ${({ theme}) => theme.colors.secondary100}
  }
  .description{
    font-size: 16px;
    color: ${({ theme}) => theme.colors.secondary70}
  }
`;
